<template>
    <div class="msg-new content-container">
        <div class="header">
            <div class="title">New Message</div>
        </div>
        <div class="content">
            <div class="content-window">
              <div class="col-forms">
                <div class="serach-control">
                  <input class="search-input" v-debounce:500ms="searchUsers" type="text" v-model="userSearch" placeholder="Search">
                  <img class="search-icon" src="icons/icon-search-3.png" alt=""/>
                  <div class="users-option-list">
                    <div class="user-option" v-for="user in avUsers" :key="user.id" @click="addUser(user)">
                      <span>
                        {{user.name}}
                      </span>
                      <span class="user-option-plus">
                        +
                      </span>
                    </div>
                  </div>
                </div>
                <div class="recipients-control">
                  <div class="recipients-header">
                    Recipients
                  </div>
                  <div class="users-option-list">
                    <div class="user-option" v-for="user in recipients" :key="user.id">
                      <span>
                        {{user.name}}
                      </span>
                      <span class="user-option-plus" @click="removeUser(user)">
                        x
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="composer-container">
                <MessageComposer v-bind="{
                  recipients: this.selectedUsersIDs,
                  cancelled: this.cancelled,
                  submitted: this.submitted,
                  showSubject: true,
                  subject: null
                }"/>
              </div>              
            </div>
            <!-- <select v-model="selectedUser">
                <option v-for="user in users" :key="user.id" :value="user.id">{{user.name}}</option>
            </select>
            <br> -->
          </div>
    </div>
</template>

<script>

import api from '../../api/api';
import MessageComposer from './MessageComposer.vue'

export default {
  components: {
    MessageComposer
  },
  methods: {
    cancelled() {
      this.users = [];
      this.selectedUsersIDs = null,
      this.userSearch = "";
      this.recipients = [];
      this.$emit('cancel');
    },
    submitted() {
      window.location.reload();
    },    
    addUser(user){
      this.recipients.push(user);
      if(!this.selectedUsersIDs){
        this.selectedUsersIDs = [];
      }
      this.selectedUsersIDs.push(user.id);
    },
    removeUser(user) {
      if(this.recipients.includes(user)){
        const index = this.recipients.indexOf(user);
        if (index > -1) {
          this.recipients.splice(index, 1);
        }
      }
      const index2 = this.selectedUsersIDs.indexOf(user.id);
      if (index2 > -1) {
        this.selectedUsersIDs.splice(index2, 1);
      }
    },
    searchUsers() {
      if(this.userSearch && this.userSearch.length >2) {
        api.get('/members/messageOptions', {
          params: {
            name: this.userSearch
          }
        }).then(r=> {
          this.users = r.data;
        })
      }
      if(this.userSearch == ''){
        this.users = [];
      }
    }
  },
  props: ['topic'],
  data(){
    return {
      users: [],
      selectedUsersIDs: null,
      userSearch: "",
      recipients: []
    };
  },
  mounted(){
    if(this.topic){
      this.recipients.push({
        id: this.topic.memberID,
        name: this.topic.memberName,
      });
      if(!this.selectedUsersIDs){
        this.selectedUsersIDs = [];
      }
      this.selectedUsersIDs.push(this.topic.memberID);
      this.subject = `Regarding your topic ${this.topic.topicTitle}`
    }
  },
  computed: {
    avUsers() {
      if(!this.selectedUsersIDs) {
        return this.users;
      }
      return this.users.filter(r => !this.selectedUsersIDs.includes(r.id));
    },
    sendDisabled() {
      return false;
    }
  }
}
</script>

